<template>
    <UiCoreSimpleRichText
        v-editable="blok"
        class="sb-core-simple-rich-text"
        data-test="sb-core-simple-rich-text"
        :blok="blok"
    />
</template>

<script setup lang="ts">
import type { ICoreSimpleRichText } from '@nuxt-monorepo/ui/types/components/CoreSimpleRichText';

defineProps<{ blok: ICoreSimpleRichText }>();
</script>

<style scoped lang="postcss">
.sb-core-simple-rich-text {
    &:deep(ul) {
        li {
            span:first-child.css-list-checkmarks:after {
                @apply block absolute text-[#0e242b] -left-5 -top-[2px] h-[24px];
                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05094 10.2212L10.0007 15.1709Z' fill='%230E242B'/%3E%3C/svg%3E");
            }
        }
    }

    &.ui-simple-rich-text {
        :deep(h1),
        :deep(h2) {
            @apply text-xl md:text-4xl leading-normal;
        }

        :deep(h3) {
            @apply text-xl md:text-3xl leading-normal;
        }

        :deep(h4) {
            @apply text-lg md:text-2xl leading-normal;
        }

        :deep(h5) {
            @apply text-base md:text-xl leading-normal;
        }

        :deep(h6) {
            @apply text-sm md:text-lg leading-normal;
        }
    }
}
</style>
